/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RescheduleAppointment
 */
export interface RescheduleAppointment {
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    appointment_id: string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleAppointment
     */
    physician_id: string;
    /**
     * 
     * @type {number}
     * @memberof RescheduleAppointment
     */
    date: number;
    /**
     * 
     * @type {number}
     * @memberof RescheduleAppointment
     */
    date_end: number;
}

/**
 * Check if a given object implements the RescheduleAppointment interface.
 */
export function instanceOfRescheduleAppointment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "appointment_id" in value;
    isInstance = isInstance && "physician_id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "date_end" in value;

    return isInstance;
}

export function RescheduleAppointmentFromJSON(json: any): RescheduleAppointment {
    return RescheduleAppointmentFromJSONTyped(json, false);
}

export function RescheduleAppointmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): RescheduleAppointment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appointment_id': json['appointment_id'],
        'physician_id': json['physician_id'],
        'date': json['date'],
        'date_end': json['date_end'],
    };
}

export function RescheduleAppointmentToJSON(value?: RescheduleAppointment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appointment_id': value.appointment_id,
        'physician_id': value.physician_id,
        'date': value.date,
        'date_end': value.date_end,
    };
}

